import { useState, useEffect } from 'react'
import ButtonItem from '@/app/[lang]/@desktop/_components/ButtonItem'
import { getPopularTags } from '@/apis/character'
import useSWR from 'swr'
import useI18n from 'Hooks/useI18n'

const PopularTags = ({ setQuery }: { setQuery: (query: string) => void }) => {
  const { t } = useI18n()
  const [popularTagsList, setPopularTagsList] = useState<
    { Score: number; Member: string }[]
  >([])
  const { data: tags } = useSWR('/search/popular_search_terms', getPopularTags)

  useEffect(() => {
    setPopularTagsList(tags || [])
  }, [tags])

  if (popularTagsList.length === 0) return null

  return (
    <div className="m-2 pl-2">
      <div className="mb-4 text-left text-sm">{t('Popular Search')}</div>
      <div className="flex flex-wrap gap-2">
        {popularTagsList.map((tag) => (
          <ButtonItem
            key={tag.Member}
            type="text"
            value={tag.Member}
            className="rounded-full border border-[rgba(255,255,255,0.05)] bg-[rgba(255,255,255,0.2)] px-3 py-1 text-xs text-[rgba(255,255,255,0.7)]"
            selectedClassName="bg-none"
            onClick={() => {
              setQuery(tag.Member)
            }}
          >
            {tag.Member}
          </ButtonItem>
        ))}
      </div>
    </div>
  )
}

export default PopularTags
